const loadTaboolaScript = (type, url) => {
  if (document.getElementById("tb_loader_script")) return null;

  window._taboola = window._taboola || [];
  _taboola.push({ // eslint-disable-line
    [type]: "auto",
    tracking: "utm_referrer=taboola"
  });

  const script = document.createElement("script");
  script.src = url;
  script.id = "tb_loader_script";
  script.async = true;
  document.head.appendChild(script);

  if (window.performance && typeof window.performance.mark === "function") {
    window.performance.mark("tbl_ic");
  }

  window._taboola = window._taboola || [];
  _taboola.push({ flush: true }); // eslint-disable-line
};

export const removeTaboolaScript = () => {
  const script = document.getElementById("tb_loader_script");
  document.head.removeChild(script);
};

export default loadTaboolaScript;
